import { Item, Product } from '~shared/models';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEventType } from '~shared/modules/ga-tracking/constants';
import { PriceTypes } from '~shared/modules/price-type-toggler/price-type-toggler.module';
import { GATrackingEvent } from '~shared/modules/ga-tracking/models';
import { Category } from '~app/modules/generic/models';
import get from 'lodash.get';
import { Variant, VariantType } from '~shared/models/product-card/product-variant.model';
import { NUMBER_0 } from '~shared/constants';

export class GaTrackingViewItemListEventModel implements GATrackingEvent {
  isGA4: boolean = true;

  constructor(private payload: any) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.ViewItemList;
  }

  getPayload(): GATrackingEventPayload {
    const { pageName, products, priceType, currency, searchTerm } = this.payload;
    return {
      event: this.getEventType(),
      gtmCustom: {
        ecommerce: {
          currency: currency,
          item_list_name: pageName,
          search_term: searchTerm,
          items: products?.map((product: Product, index: number): any =>
            // TODO: SRCH-2569 use again the common function to parse to GA4 object when it's clear how the
            //  object should be to avoid too big payload.
            this.getGA4ItemObject(product, priceType, index)
          ),
        },
      },
    };
  }

  public getGA4ItemObject(product: Product, priceType: PriceTypes, index: number): Item {
    const { startingIndex, isPlp } = this.payload;
    const categoriesList: Category[] = [...product?.categories].reverse() as any;
    const hasVariants: Variant = product?.variant;
    const productIndex = isPlp ? (startingIndex || NUMBER_0) + (index + 1) : index + 1;

    return {
      item_name: product?.name,
      item_id: product?.id,
      item_seller: product?.bestOffer?.sellerName,
      item_promo: product?.hasPromotion ? 'yes' : 'no',
      item_discount_rate: product?.bestOffer?.referencePrice?.discountPercentage,
      item_brand: product?.attributes?.brand?.name,
      item_offer_id: product?.bestOffer?.id,
      ...(categoriesList.reduce((categories: {}, category: Category, categoryIndex: number) => {
        if (categoryIndex === 0) {
          categories['item_category'] = category?.name;
        } else {
          categories[`item_category${categoryIndex + 1}`] = category.name;
        }

        return categories;
      }, {}) as any),
      item_variant: hasVariants ? this.getItemVariant(product) : null,
      index: productIndex,
      quantity: 1,
      price:
        priceType === 'entrepreneur'
          ? get(product, 'bestOffer.price.netPrice', 0)
          : get(product, 'bestOffer.price.grossPrice', 0),
    };
  }

  private getItemVariant(product: Product): string {
    const variantTypesList: [string, VariantType][] = product?.variant?.types ? Object.entries(product?.variant?.types) : [];
    const mappedEntries: string[] = variantTypesList
      .filter(([key, { value }]) => value !== null)
      .map(([key, { value }]) => `${key}=${value}`);

    return mappedEntries.join('&');
  }
}
